export default () => {
    const locationsPage = document.querySelector(".in-locations,.in-pobocky");

    if (locationsPage) {
        const locationsList = document.querySelectorAll(".custom-page .stores .stores__store");

        const brunchFlagHtml = `
        <div class="location-flags">
            <img src="/user/documents/img/BrunchMenu.png" class="location-flag-brunch"></img>
        </div>
        `

        locationsList.forEach ((location) => {
            if (location.classList.contains('brunch-available'))
            {
                $(location).prepend(brunchFlagHtml);
            }
        });
    }
};